import ADataListItem from './index.vue';

ADataListItem.install = app => {
  app.component(ADataListItem.name, ADataListItem);
};

export default ADataListItem;
